import React from "react";
import { registrarTap } from "../api";

const CardActions = ({ url, telefono, correo, id_sucursal, userId }) => {
  const acciones = [];
    
  if (url) {
    const separator = url.includes("?") ? "&" : "?";
    const fullUrl = `${url}${separator}utm_source=ubikalo&utm_medium=app`;

    acciones.push({
      label: "Sitio web",
      color: "#9FD158",
      onClick: () => {
        registrarTap(id_sucursal, "web", userId || null);         
        const a = document.createElement("a");
        a.href = fullUrl.startsWith("http") ? fullUrl : `https://${fullUrl}`;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 256 256">
            <path fill="currentColor" d="M90 24v-8a6 6 0 0 1 12 0v8a6 6 0 0 1-12 0m-74 78h8a6 6 0 0 0 0-12h-8a6 6 0 0 0 0 12m109.32-64.63a6 6 0 0 0 8.05-2.69l8-16a6 6 0 0 0-10.74-5.37l-8 16a6 6 0 0 0 2.69 8.06m-96 85.26l-16 8a6 6 0 0 0 5.36 10.74l16-8a6 6 0 1 0-5.36-10.74m188.58 62.78a14 14 0 0 1 0 19.8l-12.69 12.69a14 14 0 0 1-19.8 0l-51.31-51.31a2 2 0 0 0-3.21.54l-17.75 46.24a2 2 0 0 0-.1.24a13.85 13.85 0 0 1-12.78 8.39h-.68A13.85 13.85 0 0 1 87 212.38L34.7 52.3a14 14 0 0 1 17.6-17.6L212.38 87a14 14 0 0 1 1.23 26l-.24.09l-46.25 17.76a2 2 0 0 0-.53 3.21Zm-8.49 8.49l-51.31-51.31a14 14 0 0 1 4.32-22.74l.24-.1L208.91 102a2 2 0 0 0-.26-3.61L48.58 46.11a2.3 2.3 0 0 0-.65-.11a2 2 0 0 0-1.82 2.58l52.27 160.07a1.84 1.84 0 0 0 1.77 1.35a1.81 1.81 0 0 0 1.84-1.09l17.76-46.25l.1-.24a14 14 0 0 1 22.74-4.32l51.31 51.31a2 2 0 0 0 2.83 0l12.68-12.68a2 2 0 0 0 0-2.83" strokeWidth="6.5" stroke="currentColor" />
        </svg>
      ),
    });
  }

  if (telefono) {
    acciones.push({
      label: "Llamar",
      color: "#000000",
      onClick: () => {
        registrarTap(id_sucursal, "llamada", userId || null);
        const enlace = `tel:${telefono}`;
      
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler("abrirEnlaceExterno", enlace);
        } else {
          setTimeout(() => {
            window.location.href = enlace;
          }, 150);
        }
      },      
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" strokeWidth="0.7" stroke="currentColor" />
        </svg>
      ),
    });
  }

  if (correo) {
    acciones.push({
      label: "Correo",
      color: "#9FD158",
      onClick: () => {
        registrarTap(id_sucursal, "correo", userId || null);
        const enlace = `mailto:${correo}`;
      
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler("abrirEnlaceExterno", enlace);
        } else {
          setTimeout(() => {
            window.location.href = enlace;
          }, 150);
        }
      },
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
            <path fill="currentColor" d="M5 5h13a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 1c-.5 0-.94.17-1.28.47l7.78 5.03l7.78-5.03C18.94 6.17 18.5 6 18 6zm6.5 6.71L3.13 7.28C3.05 7.5 3 7.75 3 8v9a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V8c0-.25-.05-.5-.13-.72z" strokeWidth="0.7" stroke="currentColor" />
        </svg>
      ),
    });
  }

  const width = `${100 / acciones.length}%`;

  return (
    <div className="card-actions-container">
      {acciones.map((accion, i) => {
        const isWeb = accion.label === "Sitio web";

        const contenido = (
            <>
            <div className="card-icon">{accion.svg}</div>
            <span className="card-label">{accion.label}</span>
            </>
        );

        if (isWeb) {
            return (
            <a
                key={i}
                href={url.startsWith("http") ? url : `https://${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="card-action"
                style={{ backgroundColor: accion.color, flexBasis: width }}
                onClick={(e) => {
                  let enlace = url.trim();
                  const isMail = enlace.startsWith("mailto:");
                  const isTel = enlace.startsWith("tel:");
                  const isHttp = enlace.startsWith("http://") || enlace.startsWith("https://");
                
                  if (!isMail && !isTel) {
                    const separator = enlace.includes("?") ? "&" : "?";
                    const fullUrl = `${enlace}${separator}utm_source=ubikalo&utm_medium=app`;
                    enlace = fullUrl.startsWith("http") ? fullUrl : `https://${fullUrl}`;
                  }
                
                  registrarTap(id_sucursal, isMail ? "correo" : isTel ? "llamada" : "web", userId || null);
                
                  if (window.flutter_inappwebview) {
                    e.preventDefault();
                    window.flutter_inappwebview.callHandler("abrirEnlaceExterno", enlace);
                  }
                }}                
            >
            {contenido}
            </a>
            );
        }

        return (
            <div
            key={i}
            className="card-action"
            style={{ backgroundColor: accion.color, flexBasis: width }}
            onClick={accion.onClick}
            >
            {contenido}
            </div>
        );
        })}
    </div>
  );
};

export default CardActions;
